import React, { useContext } from "react";
import "../css/verticalnav.css";
import VerticalNavigation from "../components/VerticalNavigation";
import DataDescriptionContext from "../context/DataDescriptionContext";
import Spinner from "../components/loader";

const ReviewData = () => {
  let { responseData,loading} = useContext(DataDescriptionContext);
  // console.log("Your Response:", responseData);
  // console.log("loading..",loading);
  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        {loading?<Spinner/>:null}
        <div className="container bg-light rounded main-content  mx-2">
          <div className="review-body my-5">
            <div className="table-fixedhead1">
              <h3 className="text-center">Sample Data</h3>
              <table className="table-bordered px-3">
                <thead>
                  <tr>
                    {responseData[0].features_name.map((item) => (
                      <th scope='col'>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {responseData[0].data.slice(1,10).map((item) => (
                    <tr>
                      {item.map((itm) => (
                        <td>{itm}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="vertical-line"></div>
            <div className="">
              <h3 className="text-center">Basic Table Info</h3>
              <table className="basic-desc">
                <tbody>
                {Object.keys(responseData[1]).map((item,i)=> (
                  <tr key={i}>
                   <th>{item}</th>
                   <td>{responseData[1][item]}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewData;
